module.exports = __webpack_public_path__ + "img/omv.781229f6.png";